import { FormattedMessage, useIntl } from 'react-intl';
import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { useAppSelector } from '../../../configuration/setup/hooks';
import { isAppInMaintenanceMode } from '../../../configuration/tmpSlice';
import { isConsentsValid } from '../consents.validators';

export const ConsentsNextButton = ({ isLoading, onClick }: { isLoading: boolean; onClick: () => void }) => {
    const isValid = useAppSelector(state => !isAppInMaintenanceMode(state) && isConsentsValid(state.personalInfo));

    const intl = useIntl();

    return (
        <>
            {isLoading ? (
                <button type={'button'} disabled className={'btn btn-primary disabled'}>
                    <Spinner isInverse text={intl.formatMessage({ id: 'registration.consents.registerButtonLabel' })} />
                </button>
            ) : (
                <button
                    type={'button'}
                    disabled={!isValid}
                    onClick={e => {
                        e.preventDefault();
                        onClick();
                    }}
                    className={'btn btn-primary btn-icon-right finalize-registration-button'}
                >
                    <FormattedMessage id={'registration.consents.registerButtonLabel'} />
                </button>
            )}
        </>
    );
};
